import React from 'react'
import hoc from '@hoc'
import PropTypes from 'prop-types'
import * as utils from '@utils'
import { MuiPickersUtilsProvider, DateTimePicker } from '@material-ui/pickers'
import DateFnsUtils from '@date-io/date-fns'
import moment from 'moment'

const initState = {
    startDisabled: false,
    endDisabled: false,
    startDate: utils.datetimeStartOfWithoutOffset(utils.currentDatetime(), 'day'),
    endDate: utils.datetimeEndOfWithoutOffset(utils.currentDatetime(), 'day'),
    isRealTimeCaculation: false
}

class GameReportDatetimeSelect extends React.Component {
    constructor(props) {
        super(props)
        this.t = (key, options) => {
            return utils.t(key, 'GameReportDatetimeSelect', options)
        }
        this.state = initState
    }

    state = {
        endDateMin: utils.datetimeStartOfWithoutOffset(utils.currentDatetime(), 'day'),
        endDateMax: this.handleMaxDate()
    }

    componentDidMount() {
        if (this.props?.initDate) {
            initState.startDate = this.props.initDate.startAt
            initState.endDate = this.props.initDate.endAt
        }
        this.setState(initState)
        this.props.onRef(this)
    }

    componentWillUnmount() {
        this.props.onRef(undefined)
    }

    isDateInvalid() {
        if (utils.isDateAfter(this.state.startDate, this.state.endDate)) return true

        return false
    }
    handleMaxDate() {
        let maxDate = moment().add(100, 'y')
        if (this.props?.dateLimit) {
            const today = utils.datetimeEndOfWithoutOffset(utils.currentDatetime(), 'day')
            const limitDate = moment(this.state.startDate).add(this.props.dateLimit.count, this.props.dateLimit.type)
            maxDate = moment(limitDate).isAfter(today, 'second') ? today : limitDate
        }
        if (this.props?.endDateMaxDate) {
            maxDate = this.props.endDateMaxDate
        }
        return maxDate
    }

    render() {
        const isRealTimeCaculation = this.state.isRealTimeCaculation
        return (
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <DateTimePicker
                    invalidDateMessage={this.t('DatePicker.invalidDateMessage')}
                    maxDateMessage={this.t('DatePicker.maxDateMessage')}
                    minDateMessage={this.t('DatePicker.minDateMessage')}
                    maxDate={moment()}
                    className={this.props.options?.hide ? this.props.classes.hide : this.props.classes.textField}
                    variant="inline"
                    value={this.state.startDate}
                    onChange={
                        (date) => {
                            if (isRealTimeCaculation) {
                                this.setState({
                                    startDate: moment(date),
                                    endDate: moment(date).add({ hours: 23, minutes: 59 }),
                                    endDateMax: moment(date).add({ hours: 23, minutes: 59 }),
                                })
                            } else {
                                this.setState({
                                    startDate: moment(date).startOf('hour'),
                                    endDateMax: this.handleMaxDate()
                                })
                            }
                        }
                    }
                    views={['year', 'month', 'date', 'hours', 'minutes', 'seconds']}
                    format="yyyy/MM/dd HH:mm"
                    label={this.t('startDate')}
                    disabled={this.state.startDisabled}
                />
                <DateTimePicker
                    invalidDateMessage={this.t('DatePicker.invalidDateMessage')}
                    maxDateMessage={this.t('DatePicker.maxDateMessage')}
                    minDateMessage={this.t('DatePicker.minDateMessage')}
                    minDate={this.state.startDate}
                    maxDate={this.state.endDateMax}
                    className={this.props.options?.hide ? this.props.classes.hide : this.props.classes.textField}
                    variant="inline"
                    value={this.state.endDate}
                    onChange={
                        (date) => {
                            if (isRealTimeCaculation) {
                                const dateTimeEnd = moment(this.state.startDate).add({ hours: 23, minutes: 59 })
                                // 檢查日期是否超過起始日期後的24小時
                                if (moment(date).isAfter(dateTimeEnd)) {
                                    this.setState({
                                        endDate: dateTimeEnd
                                    })
                                    utils.addToast(this.t('isRealTimeCaculationSelectError'), 'error')
                                } else {
                                    this.setState({
                                        endDate: moment(date)
                                    })
                                }
                            } else {
                                this.setState({
                                    endDate: moment(date).endOf('hour').format()
                                })
                            }
                        }
                    }
                    views={['year', 'month', 'date', 'hours', 'minutes']}
                    format="yyyy/MM/dd HH:mm"
                    label={this.t('endDate')}
                    disabled={this.state.endDisabled}
                />
            </MuiPickersUtilsProvider>
        )
    }
}

GameReportDatetimeSelect.propTypes = {
    classes: PropTypes.objectOf(PropTypes.string),
    onRef: PropTypes.func.isRequired,
    options: PropTypes.object,
    startDateMinDate: PropTypes.any,
    dateLimit: PropTypes.object,
    endDateMaxDate: PropTypes.any,
    initDate: PropTypes.object
}

const styles = (theme) => {
    return {
        textField: {
            margin: theme.spacing(1),
            width: '150px',
        },
        hide: {
            display: 'none',
        },
    }
}

export default hoc(styles)(GameReportDatetimeSelect)
